console.log('custom-fpqv.js loaded');
window.openFPQV = function(u, triggerBtn) {
  var overlay = document.getElementById('custom-fpqv-overlay');
  var content = document.getElementById('custom-fpqv-content');
  if (!overlay) return;
  content.innerHTML = '';
  // 按钮图标转圈
  console.log('url received:', u);
  var path = u.split('?')[0];
  var triggerBtn = document.querySelector('.t4s-pr-quickview[href="' + path + '"]');
  if (triggerBtn) triggerBtn.classList.add('is--loading');
  var loadStart = Date.now();
  fetch(u + '?view=qv')
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var elapsed = Date.now() - loadStart;
      var delay = Math.max(0, 300 - elapsed);
      setTimeout(function() {
        if (triggerBtn) triggerBtn.classList.remove('is--loading');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        content.scrollTop = 0;
        content.innerHTML = html;
        content.querySelectorAll('script').forEach(function(oldScript) {
          var newScript = document.createElement('script');
          newScript.textContent = oldScript.textContent;
          document.body.appendChild(newScript);
        });
        // 触发 Shop Pay Installments 重新初始化
        if (window.Shopify && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
        // ── 锁定 payment_terms 容器高度，消除 CLS ──
        var ptWrap = content.querySelector('.custom-qv-payment-terms-wrap');
        if (ptWrap && window.ResizeObserver) {
          var ptObserver = new ResizeObserver(function(entries) {
            for (var entry of entries) {
              var h = entry.contentRect.height;
              if (h > 0) {
                ptWrap.style.minHeight = h + 'px';
                ptObserver.disconnect();
              }
            }
          });
          ptObserver.observe(ptWrap);
        }
           
      }, delay);
    })
    .catch(function() {
      if (triggerBtn) triggerBtn.classList.remove('is--loading');
      window.location.href = u;
    });
};

function closeFPQV() {
  var overlay = document.getElementById('custom-fpqv-overlay');
  if (!overlay) return;
  overlay.classList.remove('is-open');
  document.getElementById('custom-fpqv-content').innerHTML = '';
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  var closeBtn = document.getElementById('custom-fpqv-close');
  var overlay = document.getElementById('custom-fpqv-overlay');
  if (!closeBtn || !overlay) return;
  closeBtn.addEventListener('click', closeFPQV);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) closeFPQV(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeFPQV(); });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-action-quickview]');
    if (!btn) return;
    if (!document.documentElement.classList.contains('t4s-fullpage-qv')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openFPQV(btn.getAttribute('href'));
  }, true);
});

/* 拦截异常页面的t4s-pr-quickview按钮，统一走openFPQV */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.t4s-pr-quickview');
  if (!btn) return;
  if (typeof window.openFPQV !== 'function') return;
  var href = btn.getAttribute('href');
  if (!href) return;
  var path = href.split('?')[0];
  e.preventDefault();
  e.stopImmediatePropagation();
  window.openFPQV(path);
}, true);

